import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  adminHistory: [],
  allAdminHistory: []
};

export const AdminHistorysSlice = createSlice({
  name: "adminHistorys",
  initialState,
  reducers: {
    getAdminHistorysAction: (state, action) => {
      
      state.allAdminHistory = action.payload;
    },
    getAdminHistoryAction: (state, action) => {
      state.adminHistory = action.payload;
    },
  },
});

export default AdminHistorysSlice.reducer;

export const { getAdminHistorysAction, getAdminHistoryAction } = AdminHistorysSlice.actions;
